import Nav from "../components/ui/nav.ui";
import { useUserStore } from "../../store/user.store";
import Sidebar from "../components/ui/sidebar.ui";
import { Outlet } from "react-router-dom";

export const BaseBrandsLayoutScreen = () => {
  const { brands } = useUserStore();

  return (
    <div className="bg-white w-full h-screen text-soloprimary">
      {brands?.length && brands?.[0]?.id ? (
        <div className="top-0 z-30 sticky md:hidden bg-white border-black border-b rounded-b-2xl w-full">
          <Nav />
        </div>
      ) : null}
      <div className="flex items-center w-full h-full overflow-hidden">
        {brands?.length && brands?.[0]?.id ? (
          <div className="md:flex flex-col hidden w-full min-w-64 max-w-64 h-full">
            <Sidebar />
          </div>
        ) : null}
        <div className="w-full h-full overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
